module.exports = __webpack_public_path__ + "static/media/navidad.c12894d9.png";